<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            min="0"
            :error="errors.liverGptTranssaminases.length > 0"
            :error-messages="errors.liverGptTranssaminases"
            v-model="form.liverGptTranssaminases"
            :placeholder="$t('dashboard_new_evollu.measurement_types.liver_gpt_transsaminases_short')+' (U/L)'"
            :label="$t('dashboard_new_evollu.measurement_types.liver_gpt_transsaminases_short')+' (U/L)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.liverGotTranssaminases.length > 0"
          :error-messages="errors.liverGotTranssaminases"
          v-model="form.liverGotTranssaminases"
          :placeholder="$t('dashboard_new_evollu.measurement_types.liver_got_transsaminases_short')+ ' (million/mm3)'"
          :label="$t('dashboard_new_evollu.measurement_types.liver_got_transsaminases_short')+ ' (million/mm3)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.liverGptGotTranssaminases.length > 0"
          :error-messages="errors.liverGptGotTranssaminases"
          v-model="form.liverGptGotTranssaminases"
          :placeholder="$t('dashboard_new_evollu.measurement_types.liver_gpt_got_transsaminases_short')"
          :label="$t('dashboard_new_evollu.measurement_types.liver_gpt_got_transsaminases_short')"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

  </div>
</template>

<script>
import moment from "moment";
const LIVER_GPT_TRANSSAMINASES_TYPE_ID = 115
const LIVER_GOT_TRANSSAMINASES_TYPE_ID = 116
const LIVER_GPT_GOT_TRANSSAMINASES_TYPE_ID = 119

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        liverGptTranssaminases: null,
        liverGotTranssaminases: null,
        liverGptGotTranssaminases: null,
      },
      errors: {
        liverGptTranssaminases: [],
        liverGotTranssaminases: [],
        liverGptGotTranssaminases: [],
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 29
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.liverGptTranssaminases !== null && this.form.liverGptTranssaminases !== '' && this.errors.liverGptTranssaminases.length === 0) ||
        (this.form.liverGotTranssaminases !== null && this.form.liverGotTranssaminases !== '' && this.errors.liverGotTranssaminases.length === 0) ||
        (this.form.liverGptGotTranssaminases !== null && this.form.liverGptGotTranssaminases !== '' && this.errors.liverGptGotTranssaminases.length === 0)

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.liverGptTranssaminases": function(value) {
        if(value !== '' && (value <= 0)) {
          this.errors.liverGptTranssaminases = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
        }
        else {
          this.errors.liverGptTranssaminases = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === LIVER_GPT_TRANSSAMINASES_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === LIVER_GPT_TRANSSAMINASES_TYPE_ID)
          elem.value = this.errors.liverGptTranssaminases.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.liverGptTranssaminases.length === 0 ? value : null,
            typeId: LIVER_GPT_TRANSSAMINASES_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.liverGotTranssaminases": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.liverGotTranssaminases = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.liverGotTranssaminases = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === LIVER_GOT_TRANSSAMINASES_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === LIVER_GOT_TRANSSAMINASES_TYPE_ID)
        elem.value = this.errors.liverGotTranssaminases.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.liverGotTranssaminases.length === 0 ? value : null,
          typeId: LIVER_GOT_TRANSSAMINASES_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.liverGptGotTranssaminases": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.liverGptGotTranssaminases = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.liverGptGotTranssaminases = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === LIVER_GPT_GOT_TRANSSAMINASES_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === LIVER_GPT_GOT_TRANSSAMINASES_TYPE_ID)
        elem.value = this.errors.liverGptGotTranssaminases.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.liverGptGotTranssaminases.length === 0 ? value : null,
          typeId: LIVER_GPT_GOT_TRANSSAMINASES_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
